import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensUAShirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[21].productName}
				color={product.allGear[21].color}
				size={product.allGear[21].sizes}
				price={product.allGear[21].price}
				img={product.allGear[21].img}
				miniImg1={product.allGear[21].miniImg1}
				miniImg2={product.allGear[21].miniImg2}
				miniImg3={product.allGear[21].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensUAShirt;
